module.exports = __webpack_public_path__ + "img/qr-code2.40b39322.png";